<template>
  <!--整体部分-->
  <div class="bodys">
    <!--头部部分-->
    <div class="header">
      <!--菜单部分-->
      <div class="heads">
        <!--头部图标部分-->
        <div class="head_up" style="float: left;width: 50px;margin-top: 5px;margin-right: 5px;">
          <router-link to="/" style="">
            <img src="@/assets/zlogo.png" alt=" " style="width: 50px;height: 50px;">
          </router-link>
        </div>
        <!--头部名字部分-->
        <div class="head_up" style="float: left;width: 190px;line-height: 60px;">
          <router-link to="/">
            郑记面条加工店
          </router-link>
        </div>
        <!--头部菜单部分-->
        <div class="head_up" style="float: left;width: 500px;text-align: center;">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            background-color="#333"
            text-color="#fff"
            active-text-color="#ff6700"
            router>
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/allgoods">所有商品</el-menu-item>
            <el-menu-item index="/shoporder">商户订单</el-menu-item>
            <el-menu-item index="/message">留言咨询</el-menu-item>
            <el-menu-item index="/about">关于我们</el-menu-item>
          </el-menu>
        </div>
        <!--头部搜索登录部分-->
        <div class="head_up" style="float: left;width: 450px;">
          <!--搜索-->
          <div style="width: 230px;float: left;line-height: 60px;">
          <el-input placeholder="请输入商品名查询" v-model="input" class="input-with-select" style="width: 230px;" @keyup.enter.native="searchGoodsList">
            <el-button slot="append" icon="el-icon-search" style="width: 50px;" @click="searchGoodsList"></el-button>
          </el-input>
          </div>
          <!--购物车-->
          <div class="cars" id="N_carlogin"><!--购物车未登录-->
            <a href="javascript:;" @click="openlogin">
              <div>
                <i class="el-icon-shopping-cart-2" style="font-size: 20px;"></i>&nbsp;购物车（0）
              </div>
            </a>
          </div>
          <div class="carses" id="Y_carlogin"><!--购物车已登录-->
              <el-popover
                placement="bottom"
                width="300px"
                trigger="hover"
                @show="getallcarlist()">
                <div class="playlistbox_botton" v-loading="loading">
                  <table width="300px" height="*" border="0" v-for="cars in carlist" :key="cars.id" >
                    <tr>
                      <td width="70px">
                        <div style="text-align: center;">
                          <router-link :to="'/goodsinfor?id='+cars.g_id" style="color: #000000;">
                            <img :src="cars.img" alt=" " width="65px">
                          </router-link>
                        </div>
                      </td>
                      <td width="130px">
                        <router-link :to="'/goodsinfor?id='+cars.g_id" style="color: #000000;">
                          <div class="titleCarlist" style="margin-left: 5px;margin-right: 5px;">
                            <el-tag size="mini" type="danger" v-if="cars.g_type=='1'">下架</el-tag>
                            <el-tag size="mini" type="danger" v-else-if="cars.number=='0'">售空</el-tag>
                            {{cars.name}}
                          </div>
                        </router-link>
                      </td>
                      <td width="100px">
                        <div style="text-align: center;">
                          {{getFmoney(cars.money,cars.discount)}}元*{{cars.num}}&nbsp;
                          <a href="javascript:;" style="color: #000000;" @click="deleteCarlist(cars)">x</a>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3">
                        <hr>
                      </td>
                    </tr>
                  </table>
                  <div style="width: 300px;text-align: center;" v-if="carnumber>allcarlist.pageSize">
                  <el-divider>
                    <a href="javascript:;" @click="getmorecarlist" style="color: #aaa;">
                      点击加载更多
                    </a>
                  </el-divider>
                  </div>
                  <div style="width: 300px;text-align: center;" v-else-if="carnumber==0"></div>
                  <div style="width: 300px;text-align: center;" v-else>
                    <el-divider>
                      <span style="color: #aaa;">
                        我也是有底线的
                      </span>
                    </el-divider>
                  </div>
                </div>
                <div v-if="carlist.length>0">
                  <div style="height: 10px;"></div>
                  <table width="300px" height="*" border="0" style="text-align: center;">
                    <tr>
                      <td width="50%">
                        共{{carnumber}}件商品<br>
                        <span style="font-size: 20px;color: #ff6700;">{{Add_Sum_money().totalPrice}}元</span>
                      </td>
                      <td>
                        <router-link to="/car" style="color: #000000;">
                          <el-button type="primary">去购物车结算</el-button>
                        </router-link>
                      </td>
                    </tr>
                  </table>
                </div>
                <div style="width: 300px;text-align: center;line-height: 100px;" v-loading="loading" v-else>
                  您还没有选择商品哦！！
                </div>
                <div slot="reference">
                  <router-link to="/car" style="color: #000000;">
                    <a href="javascript:;">
                      <div v-if="carnumber<=0">
                        <i class="el-icon-shopping-cart-2" style="font-size: 20px;"></i>&nbsp;购物车（{{carnumber}}）
                      </div>
                      <div v-else>
                        <i class="el-icon-shopping-cart-full" style="font-size: 20px;"></i>&nbsp;购物车（{{carnumber}}）
                      </div>
                    </a>
                  </router-link>
                </div>
              </el-popover>
          </div>
          <!--登录状态-->
          <div style="width: 60px;float: left;text-align: right;font-size: 14px;">
            <div style="width: 60;line-height: 60px;" id="N_userLogin">
              <span style="float: right;">
                <a href="javascript:;" @click="openlogin">登录</a>
              </span>
            </div>
            <div style="width: 60;margin-top: 15px;display: none;" id="Y_userLogin">
              <span style="float: right;">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    <span v-if="notifynumber!=0">
                      <el-badge is-dot class="item">
                        <el-avatar size="small" :src="UserInfor.photo"></el-avatar>
                      </el-badge>
                    </span>
                    <span v-else>
                      <el-avatar size="small" :src="UserInfor.photo"></el-avatar>
                    </span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <router-link to="/users/self" style="color: #000000;">
                        <i class="el-icon-user"></i>我的主页
                      </router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/users/myorder" style="color: #000000;">
                        <i class="el-icon-tickets"></i>我的订单
                      </router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <router-link to="/notify/sysnotice" style="color: #000000;">
                        <i class="el-icon-bell"></i>通知信息
                      <span v-if="notifynumber!=0">
                        <el-badge :value="notifynumber" :max="99" class="item"></el-badge><!--数量-->
                      </span>
                      </router-link>
                    </el-dropdown-item>
                    <el-dropdown-item><router-link to="/users/update" style="color: #000000;"><i class="el-icon-setting"></i>个人设置</router-link></el-dropdown-item>
                    <el-dropdown-item><a href="javascript:;" style="color: #000000;" @click="exitLogin"><i class="el-icon-edit"></i>退出</a></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--身体部分-->
    <div class="mains">
      <div class="main">
        <router-view :key="keys"/>
      </div>
    </div>
    <!--底部备案信息-->
    <div class="footer">
      <div class="footers">
        版权所有 © 2019-2021 All Rights Reserved
        <br>
        <a href="http://beian.miit.gov.cn/" target="_blank" style="color: #000000;">
          黔ICP备19008274号-1
        </a>
        <br>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52052102000035" target="_blank" style="color: #000000;">
          <img src="@/assets/beian_photo.png" alt=" ">
          贵公网安备 52052102000035号
        </a>
      </div>
    </div>

    <!--登录框架-->
    <div class="logindiv" id="loginmain">
      <Login-login></Login-login>
    </div>

    <!--注册框架-->
    <div class="registerdiv" id="registermain">
      <Login-register></Login-register>
    </div>

    <!--忘记密码框架-->
    <div class="logindiv" id="passwordMain">
      <Login-repassword></Login-repassword>
    </div>


    <!--黑幕遮挡-->
    <div class="zhedang" id="zhedang"></div>

    <el-backtop>
      <div style="{
              height: 100%;
              width: 100%;
              background-color: #f2f5f6;
              box-shadow: 0 0 6px rgba(0,0,0, .12);
              text-align: center;
              line-height: 40px;
              color: #1989fa;
            }" >
        UP
      </div>
    </el-backtop>

  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  import {codeAPI} from '@/api/codeAPI'
  import Login_login from '@/components/LoginPage/loginpage_login.vue'//登录组件
  import Login_register from '@/components/LoginPage/loginpage_register.vue'//登录组件
  import Login_repassword from '@/components/LoginPage/loginpage_repassword.vue'//登录组件
export default {
  components: {
    'Login-login': Login_login,
    'Login-register': Login_register,
    'Login-repassword': Login_repassword,
  },
  created () {
      //判定会话是否过期
      let data = JSON.parse(window.localStorage.getItem("store"));
      if(data!=null&&data!=''&&data!='null'){
        //console.log(data)
        sessionStorage.removeItem("token");//口令
        sessionStorage.removeItem("store");
        sessionStorage.setItem("token",this.getlocalStorage("token"))//口令
        sessionStorage.setItem("store",JSON.stringify(this.getlocalStorage("store")))
      }
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store")) {
        //console.log("加载："+sessionStorage.getItem("store"))
        let data=JSON.parse(sessionStorage.getItem("store"))
        this.$store.commit({
          type:'changeUserInfor',
          u_token:data.u_token,
          u_id:data.u_id,
          name:data.name,
          phone:data.phone,
          photo:data.photo,
          sex:data.sex,
          email:data.email,
          signature:data.signature,
          shop_type:data.shop_type,
        });
        sessionStorage.removeItem("token");//口令
        sessionStorage.setItem("token",this.$store.state.u_token)//口令
        sessionStorage.removeItem("store");
      }
    },
  data () {
    return {
      //用户密码前端salt
      usersalt:'havetorich',
      //用户相关信息
      UserInfor:{
        photo:'',
        name:'',
        id:'',
        token:'',
        email:'',
        phone:'',
        sex:'',
        signature:'',
        shop_type:'',
      },
      loading: false,   //登陆加载效果
      //页面定位
      activeIndex: this.$route.path,
      //搜索查询输入框
      input: '',
      //通知数量
      notifynumber:0,
      //购物车相关
      carnumber:0,
      carlist:[],
      allcarlist:{
        u_id:'',
        nowTime:'',
        pageNum:1,
        pageSize:3
      },
      //消息数量
      informNumber:0,

    }
  },
  //页面重新渲染
  computed:{
    keys(){
      return this.$route.name?this.$route.name+ +new Date():this.$route+ +new Date()
    }
  },
  //页面自动执行
  mounted(){
    this.judgeLogin();
    //console.log(this.registerForm.checked)
    /**密码加密
    let data = this.$md5(this.pass)
    */
  },
  //方法
  methods: {
    //进行会话存储
    setlocalStorage(key,value,time){
      let data={ value: value, expirse: new Date(time).getTime() };
      window.localStorage.setItem(key,JSON.stringify(data))
    },
    getlocalStorage(key){
      let data = JSON.parse(window.localStorage.getItem(key));
      if (data!=null||data!='') {
          if (data.expirse != null && data.expirse < new Date().getTime()) {
              window.localStorage.removeItem(key);
          } else {
              return data.value;
          }
          return null;
      }
    },
    //!会话存储结束
    //判断是否阻止弹出窗口
    ejectwindow(){
      var a = window.open("https://www.baidu.com/");
      if(a==null){
        alert("当前新窗口已被浏览器拦截,请点击窗口右上角的设置,允许弹出!")
      }
    },
    //获取消息通知
    getinformnumber(){
      let i=0;
      commonAPI('queryInformNumber', this.UserInfor).then(res => {
        i=res.data.data
        this.informNumber=i;
        this.notifynumber=i;
        //console.log(i)
      })
    },
    //商品的搜索方法
    searchGoodsList(){
      let search=this.input;
      if(search==''||search=='null'||search=='undefined'){
        return false;
      }else{
        this.$router.push(
            {
              name: 'allgoods',
              params: {
                search: search
              }
            }
        )
      }
    },
    //获取信息方法
    judgeLogin(){
      //console.log(this.$store.state.name.id);
      //console.log(this.UserInfor.id.length);
      if (this.$store.state.u_id.length>0) {
        this.UserInfor.id=this.$store.state.u_id;
      }else{
        sessionStorage.removeItem("token");
        //console.log("No Logining!!");
      }
      if(this.UserInfor.id.length>0){
        document.getElementById('N_userLogin').style.display='none';
        document.getElementById('Y_userLogin').style.display='block';
        document.getElementById('Y_carlogin').style.display='block';
        document.getElementById('N_carlogin').style.display='none';
        //console.log(this.saveLogin.getUser_infor())
        this.UserInfor.id=this.$store.state.u_id
        this.UserInfor.photo=this.$store.state.photo
        this.UserInfor.name=this.$store.state.name
        this.UserInfor.phone=this.$store.state.phone
        this.UserInfor.email=this.$store.state.email
        this.UserInfor.sex=this.$store.state.sex
        this.UserInfor.token=this.$store.state.u_token
        this.UserInfor.signature=this.$store.state.signature
        this.UserInfor.shop_type=this.$store.state.shop_type
        this.saveLogin.saveLogining_user(this.UserInfor);
        this.getCarNumber();
        this.getinformnumber();
        /**
        commonAPI('queryUser_1', this.UserInfor).then(res => {
          if(res.data.data.userList!='error'){
            let data=res.data.data.userList[0];
            this.UserInfor.id=data.id;
            this.UserInfor.name=data.name;
            this.UserInfor.photo=data.photo;
            this.saveLogining();
            this.getCarNumber();
            this.getinformnumber();
          }else{
            //提示信息
            this.$message({
              message: '凭证过期！请重新登录！',
              type: 'error'
            });
            setTimeout(() => {
              this.exitLogin();
            },1500)
          }
        });
        */
      }
    },
    //子页面获取token
    childrengetTokenCookie(){
      if (document.cookie.length>0) {
       let arr=document.cookie.split('; ');//这里显示的格式需要切割一下自己可输出看下
       for(let i=0;i<arr.length;i++){
        let arr2=arr[i].split('=+=');//再次切割
        //判断查找相对应的值
        if(arr2[0]=='u_id'){
         this.UserInfor.id=arr2[1];
        }
       }
      }
      return this.UserInfor.id;
    },
    //退出登录
    exitLogin(){
      window.localStorage.removeItem("store");
      window.localStorage.removeItem("token");
      sessionStorage.removeItem("store");
      sessionStorage.removeItem("token");
      this.UserInfor.id='';
      this.UserInfor.name='';
      this.UserInfor.photo='';
      //跳转
      this.$router.push({path: "/"});
      setTimeout(() => {
        this.$router.go(0);
      },100)
    },

    //登录注册窗口相关
    openlogin(){
      let u_id=this.UserInfor.id;
      if(u_id!=""){
        this.$notify({
        title: '提示',
        message: '你已经登录',
        position: 'bottom-right',
        type: 'success'
        });
      }else{
        document.getElementById('loginmain').style.display='block';
        document.getElementById('zhedang').style.display='block';
      }
    },

    //搜索方法
    search(content){
      let search=this.input;
      if(search==""||search==null||search=="null"){
        return false;
      }
      if(content!=''){
        this.input=content;
      }
      let sc=this.select;
      this.$router.push({path: '/search',query: {s:search}})
    },
    //购物车获取数量
    getCarNumber(){
      if(this.UserInfor.id!=""){
        commonAPI('queryCarNumber', this.UserInfor).then(res => {
          this.carnumber=res.data.data
          //console.log(res.data)
        })
      }
    },
    //获取更多购物车内容
    getmorecarlist(){
      this.allcarlist.pageSize+=3
      this.getallcarlist();
    },
    //复原购物车底数

    //购物车获取内容
    getallcarlist(){
      this.loading=true;
      let time =new Date().getTime();
      this.allcarlist.nowTime=time;
      this.allcarlist.u_id=this.UserInfor.id;
      commonAPI('queryCarList', this.allcarlist).then(res => {
        this.carlist=res.data.data.rows;
        this.loading=false;
      })
    },
    //删除购物车商品
    deleteCarlist(cc){
      cc.u_id=this.UserInfor.id;
      commonAPI('deleteCar', cc).then(res => {
        let data=res.data
        if(this.response.response(data)){
          this.getCarNumber();
          this.getallcarlist();
        }
      }).catch(error=>{
              this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
    },
    //计算总价
    Add_Sum_money(){
      var pro=this.carlist.filter(function(item){
      return item.type==false;
      });
      var totalPrice=0;
      for(var i = 0; i < pro.length;i++){
        let one_money=this.getFmoney(this.getFmoney(pro[i].money,pro[i].num),pro[i].discount)
        totalPrice+=parseFloat(one_money);
      }
      length=pro.length;
      return {totalPrice:this.getFmoney(totalPrice,1)}
    },
    //价钱浮动计算方法
    getFmoney(money,discount){
      let m=0,s1=money.toString(),s2=discount.toString(),sum=0;
      try{m+=s1.split(".")[1].length}catch(e){}
      try{m+=s2.split(".")[1].length}catch(e){}
      sum=Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
      return sum.toFixed(2);
    },

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bodys{
    width:100%;
    height: 100%;
    overflow: auto;
    border: 0px solid #333;
    background-color: #f5f5f5;
  }
  .header{
    width:100%;
    min-width: 1200px;
    height: 3.77rem;
    overflow: hidden;
    margin: 0 auto;
    border: 0px solid #ff0080;
    background-color: #333;
    color: #fff;
  }
  .heads{
    width: 1200px;
    overflow: hidden;
    margin: 0 auto;
    height: 100%;
    color: #fff;
  }
  .head_up{
    border: 0px solid #fff;
    overflow:hidden;
  }
  .head_up a{
    color: #fff;
  }
  .head_up a:hover{
    color:#ff6700;
  }
  .cars{
    width: 120px;height:60px;float: left;text-align: center;font-size: 14px;margin-left: 20px;line-height: 60px;background-color: #424242;
  }
  .cars:hover{
    color: #ff6700;
    background-color: #ffffff;
  }
  .carses{
    width: 120px;height:60px;float: left;text-align: center;font-size: 14px;margin-left: 20px;line-height: 60px;background-color: #424242;display: none;
  }
  .carses:hover{
    color: #ff6700;
    background-color: #ffffff;
  }

  .mains{
    width: 100%;
    margin: 0 auto;
    min-width: 1200px;
    overflow: hidden;
  }
  .main{
    width: 1000px;
    min-height: 800px;
    margin: 0 auto;
    background-color: #fff;
    border-left: 0.05rem solid #aaaaaa;
    border-right: 0.05rem solid #aaaaaa;
  }

  .footer{
    width: 100%;
    min-width: 1200px;
    overflow: hidden;
    background-color: #f7f7f7;
    color: #333;
    text-align: center;
    border-top: 0.05rem solid #aaaaaa;
  }
  .footers{
    width: 1000px;
    height: 108px;
    margin: 0 auto;
    font-size: 16px;
    border: 0px solid #ff0080;
    line-height: 35px;
  }

  /**遮挡css*/
  .zhedang{
  	position: fixed;
      top: 0;
      width: 100%;
      height: 100%;
      padding: 20px;
      border: 1px solid #ddd;
      background-color: #000;
      opacity: 0.5;
      z-index:200;
      overflow: auto;
      min-width:1200px;
      display: none;
  }

  /**注册框架*/
  .registerdiv{
    position: fixed;
    top: 15%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display:none;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 20%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display: none;
  }

  .playlistbox_botton{
     width: 305px;
  	  margin: 0 auto;
  	  overflow: hidden;
  	  max-height: 300px;
     overflow-y: scroll;
   }
   /**滚动条样式*/
   .playlistbox_botton::-webkit-scrollbar{
     width: 5px;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     border-radius: 10px;
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     background: #535353;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     border-radius: 10px;
     background: #EDEDED;
   }

   .titleCarlist{
   width:120px;
   overflow:hidden;
   text-overflow:ellipsis;
   white-space:nowrap;
   word-break:keep-all;
   }

</style>



// WEBPACK FOOTER //
// src/components/Index.vue